import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromField from '../_reducers/field';

export const selectFieldState = createFeatureSelector<fromField.FieldState>('fields');

export const selectAllFields = createSelector(selectFieldState, fromField.selectAll);

export const selectFieldEntities = createSelector(selectFieldState, fromField.selectEntities);

export const selectFieldById = (id: number) =>
  createSelector(selectFieldEntities, (entities) => entities[id]);

export const selectFieldTotal = createSelector(selectFieldState, fromField.selectTotal);

export const selectFieldWithStatus = createSelector(
  selectFieldState,
  selectAllFields,
  (state, fields) => ({
    fields,
    loading: state.loading,
    loaded: state.loaded,
    cropsLoaded: state.cropsLoaded,
    error: state.error,
  })
);
